import { MaterialTableColumn } from "shared/components/materialTable/types";
import { ParticipantName } from "shared/components/participantName";
import { Copies } from "shared/hooks/useCopies";
import { ApiEventParticipant } from "shared/types/ApiEventParticipant";
import { ApiEventParticipantForContactContext } from "shared/types/contact/ApiEventParticipantForContactContext";

interface leadCaptureFormFieldsType {
  [k: string]: string;
  ADMINS: "admins";
  LICENSEES: "licensees";
}

export const leadCaptureFormFields: leadCaptureFormFieldsType = {
  LABEL: "label",
  CONTACT_MODE: "contactMode",
  LICENSE_CAP: "licenseCap",
  UNLIMITED_LICENSE_CAP: "unlimitedLicenseCap",
  ADMINS: "admins",
  LICENSEES: "licensees",
  CONTACT_CONTEXT_LOCATION: "contactContextLocation",
  EVENT_ID: "eventId",
  ACCESS_CRITERIA: "accessCriteria",
  LICENSE_CRITERIA: "licenseeCriteria",
  ACCESS_CONTROL_POLICY: "accessControlPolicy",
  DESCRIPTION: "description",
  LICENSE_CRITERIA_DESCRIPTION: "licenseCriteriaDescription",
  ACCESS_CRITERIA_DESCRIPTION: "accessCriteriaDescription",
  ENFORCE_TIME_VALIDATION: "enforceTimeValidation"
};

export function getParticipantsFromParticipantIds(
  participantsMap: Record<string, ApiEventParticipantForContactContext | ApiEventParticipant>,
  participantIds: Array<string>
) {
  return participantIds
    .map((id, index) => {
      return participantsMap[id];
    })
    .filter(Boolean)
    .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`));
}

export function getCommonColumnsForContactContext(copies: Copies, eventParticipantId?: string) {
  const columnList: Array<MaterialTableColumn<ApiEventParticipant | ApiEventParticipantForContactContext>> = [
    {
      name: copies.get("name"),
      Cell: participant => <ParticipantName {...participant} self={participant.id === eventParticipantId} />,
      width: 25
    },
    {
      name: copies.get("job.title"),
      Cell: participant => (participant.jobTitle ? participant.jobTitle : "-"),
      width: 25
    },
    {
      name: copies.get("organization"),
      Cell: participant => participant.eventOrganization,
      width: 43
    }
  ];
  return columnList;
}
